exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.required[data-v-1f851f60] {color: red;}\n", ""]);

